export class ItemPagarMe {
	amount: number;	
	description: string;
	quantity: string;
	code: number;

	constructor() {
	
	}
}